import { styled } from '@mui/material/styles';
import React from 'react';
import { IconButton } from '@mui/material';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(1),
}));

interface IProps {
  icon: React.ReactNode;
  onClick: VoidFunction;
  className?: string;
  ariaLabel?: string;
}

export const LeftAppBarButton = (props: IProps) => {
  return (
    <StyledIconButton
      edge="start"
      className={props.className}
      color="inherit"
      onClick={props.onClick}
      aria-label={props.ariaLabel}
      size="large"
    >
      {props.icon}
    </StyledIconButton>
  );
};
